import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

export function withRouter<P extends object>(Component: React.ComponentType<P>) {
  return function WithRouterWrapper(props: Omit<P, "history" | "match" | "location">) {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    const history = {
      push: navigate,
      replace: (path: string) => navigate(path, { replace: true }),
    };

    const match = {
      params,
    };

    return (
      <Component
        {...(props as P)}
        history={history}
        match={match}
        location={location}
      />
    );
  };
}
